import React from "react";
import Image from "next/image";
import { Button } from "@/components/ui/button";

type PromoCtaProps = {
  imageUrl: string;
  headingtext: string;
  buttonText: string;
  onButtonClick: () => void;
};

const PromoCta: React.FC<PromoCtaProps> = ({
  imageUrl,
  headingtext,
  buttonText,
  onButtonClick,
}) => {
  return (
    <div className="fixed bottom-0 right-[13.94rem] flex h-[15.625rem] w-[18.75rem] select-none flex-col justify-between rounded-t-3xl shadow-lg">
      <div className="relative h-full w-full">
        <Image
          src={imageUrl}
          alt="Promo"
          className="h-full w-full rounded-t-3xl object-cover"
          fill
          priority
        />
        <div className="absolute inset-0 rounded-t-3xl bg-black opacity-50"></div>
        <h3
          className="absolute left-4 top-4 z-10 font-regular text-xl text-white"
          dangerouslySetInnerHTML={{ __html: headingtext }}
        ></h3>
      </div>
      <Button
        onClick={onButtonClick}
        className="absolute bottom-6 right-6 z-10 rounded-full bg-primary px-4 py-2 uppercase text-white"
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default PromoCta;
